/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CallRecordingDto = {
    recordingSid?: string;
    callSid?: string;
    to?: string;
    consentType?: string;
    referralId?: string;
    direction?: CallRecordingDto.direction;
}

export namespace CallRecordingDto {

    export enum direction {
        INBOUND = 'inbound',
        OUTBOUND = 'outbound',
    }


}
